import React from "react";

const HeaderSdg = props => {
    return (
        <div className="sdg-header" id="header2-1-2">
            <div className="text-center">
                <h4>{props.title}</h4>
                <h2 className="paragraph_subtitle">{props.subtitle}</h2>
                {props.badges ? props.badges.map((badge, i) => renderBadge(i, badge.color, badge.text)) : ''}
            </div>
            {props.target ? renderTarget(props.target.title, props.target.text, props.target.sdg) : ''}
        </div>
    ) 
}

const renderBadge = (i, color, text) => {
    return(
        <React.Fragment key={i}>
            <div className="badge badge-pill" style={{background: color}}>{text}</div>
            <br />
        </React.Fragment>
    );
}

const renderTarget = (title, text, sdg) => {
    return(
        <div className={`subtarget sub-${sdg}`}>
            <h2>{title}</h2>
            <p>{text}</p>
        </div>
    );
}

export default HeaderSdg;
